import api from './api';

export interface CustoOp {
  id: string;
  op_id: string;
  op_numero?: string | null;
  op_status?: string | null;
  produto_codigo?: string | null;
  produto_nome?: string | null;
  quantidade_produzida?: number | null;
  custo_mp_previsto: number;
  custo_mp_real: number;
  custo_mdo_previsto: number;
  custo_mdo_real: number;
  custo_indiretos_previsto: number;
  custo_indiretos_real: number;
  custo_unitario_padrao: number;
  custo_unitario_real: number;
  custo_total_previsto: number;
  custo_total_real: number;
  variacao: number;
  variacao_percentual: number;
  data_calculo?: string | null;
}

const ENDPOINT = '/industrializacao/custo-op';

const custoOpService = {
  async listar(filters: { op?: string } = {}): Promise<CustoOp[]> {
    const response = await api.get<CustoOp[]>(ENDPOINT, { params: filters });
    return response.data;
  },
  async buscarPorOP(opId: string): Promise<CustoOp[]> {
    const response = await api.get<CustoOp[]>(ENDPOINT, { params: { op: opId } });
    return response.data;
  },
  /** Calcula (cria/atualiza) o registro de custo de uma OP */
  async calcular(opId: string): Promise<CustoOp> {
    const response = await api.post<CustoOp>(`${ENDPOINT}/calcular`, { op_id: opId });
    return response.data;
  },
  /** Recalcula um registro de custo ja existente */
  async recalcular(custoId: string): Promise<CustoOp> {
    const response = await api.post<CustoOp>(`${ENDPOINT}/${custoId}/recalcular`);
    return response.data;
  },
};

export default custoOpService;
